export function Pipeline() {
  return (
    <section className="about-wrap-layout1 single-departments-box-layout1">
      <div className="container">
        <div className="row">
          <div className="sidebar-widget-area col-xl-4 col-lg-4 col-12 no-equal-item"></div>
          <div className="about-box-layout1 col-xl-8 col-12">
            <div className="item-content" style={{ marginBottom: 0 }}>
              <div className="item-cost">
                <h3 className="item-title title-bar-primary7">
                  API Products Under Pipeline/Development
                </h3>
                <ul>
                  <li style={{ background: "#1592d1" }}>
                    <h3 style={{ color: "#fff", margin: 0 }}>RARE DRUGS</h3>
                  </li>
                  <li>2-amino acetophenone</li>
                  <li>2-(Chloromethyl)-4-Methylquinazoline</li>
                  <li>Atorvastatin Calcium</li>
                  <li>Rosvastatin Calcium</li>
                  <li>Metaproloal</li>
                  <li>Pentaprazole</li>
                  <li>Febuxostate</li>
                  <li>Etorecoxib</li>
                  <li style={{ background: "#1592d1" }}>
                    <h3 style={{ color: "#fff", margin: 0 }}>
                      ANTI-Hypertensive
                    </h3>
                  </li>
                  <li>Nicardipine HCL</li>
                  <li style={{ background: "#1592d1" }}>
                    <h3 style={{ color: "#fff", margin: 0 }}>
                      HAEMATOLOGICALS
                    </h3>
                  </li>
                  <li>Ferric Citrate</li>
                  <li>Iron Sucrose</li>

                  <li style={{ background: "#1592d1" }}>
                    <h3 style={{ color: "#fff", margin: 0 }}>
                      ANTI-CANCER(Under Development)
                    </h3>
                  </li>
                  <li>Bendamustine</li>
                  <li style={{ background: "#1592d1" }}>
                    <h3 style={{ color: "#fff", margin: 0 }}>Cosmetics API</h3>
                  </li>
                  <li>Caprylolyl glycine</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
